import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react'
import React from 'react'

const FormInput = ({ isRequired, error, onChange, onBlur, id, value, label, placeholder, type, ...rest }) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={Boolean(error)} {...rest}>
      <FormLabel>{label}</FormLabel>
      <Input
        h="48px"
        id={id}
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}

export default FormInput
